/**
 * Dashboard - View an existing casting (simple layout for printing, PDF or sharing by email).
 */

'use strict';

// Constructor
var FrontDashboardCastingView = function () {
    if (!$('body').hasClass('casting-view')) {
        return;
    }

    $(document).ready((function () {
        this.init();
        this.print();
    }).bind(this));
};

FrontDashboardCastingView.prototype = {
    /**
     * Init layout and components.
     */
    init: function() {
        $('#grid .items').sortable();
    },

    /**
     * Print the casting.
     */
    print: function() {
        if ($('body').hasClass('casting-view-print')) {
            window.print();
        }

        $('.btn-print').on('click', function(e) {
            e.preventDefault();
            window.print();
        });
    },
};

module.exports = new FrontDashboardCastingView();
